"use strict";
import React from "react";
import { successIcon } from "../icons";
export class Notification extends React.Component {
  render() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "data-component": "Notification",
        className: "v3__notification v3__notification--inline v3__notification--success"
      },
      /* @__PURE__ */ React.createElement("span", { className: "v3__notification-icon v3__notification-icon--inline" }, successIcon()),
      /* @__PURE__ */ React.createElement("div", { className: "v3__notification-text v3__notification-text--column" }, this.props.title && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "v3__notification-text-title",
          style: { display: "flex" }
        },
        /* @__PURE__ */ React.createElement("span", null, this.props.title)
      ), /* @__PURE__ */ React.createElement("span", { className: "v3__notification-text-message" }, this.props.message)),
      this.props.action
    );
  }
}
